<template>
  <section>
    <p class="pricing__type">Total</p>
    <div class="pricing__total-group">
      <div class="pricing__line">
        <p class="pricing__label">subtotal</p>
        <p class="pricing__value">
          <span>{{ currencySymbol }}</span>
          <span>{{ subtotal }}</span>
        </p>
      </div>
      <div class="pricing__line">
        <p class="pricing__label">discount</p>
        <p class="pricing__value">
          <template v-if="isBlackFridayActive">
            <template>
              <span v-if="showPromotionSavings" class="pricing__value--bf-discount">
                Black Friday savings applied!
              </span>
            </template>
          </template>
          <template v-if="isLeapYearPromoActive">
            <template>
              <span v-if="showPromotionSavings" class="pricing__value--bf-discount">
                Leap Year savings applied!
              </span>
            </template>
          </template>
          <span>{{ currencySymbol }}</span>
          <span>{{ discount }}</span>
        </p>
      </div>
      <div class="pricing__line">
        <p class="pricing__label">tax</p>
        <p class="pricing__value">
          <span>{{ taxes > 0 ? `${currencySymbol}${taxes}` : 'Not Included' }}</span>
        </p>
      </div>
      <div class="pricing__total">
        <p class="pricing__label pricing__label--total">
          {{ taxes > 0 ? 'Total due today' : 'Total before tax' }}
        </p>
        <p class="pricing__value pricing__value--total">
          <span>{{ currencySymbol }}</span>
          <span>{{ total }} USD</span>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { promoProductBundleUtils, priceDetailUpdates } from '@/helpers/mixins'

export default {
  name: 'PricingListPriceDetails',
  mixins: [promoProductBundleUtils, priceDetailUpdates],
}
</script>

<style lang="scss">
.pricing {
  &__type {
    font-family: var(--font-regular);
    color: var(--white);
    font-size: rem(20px);
    line-height: 26px;
    text-align: left;
    font-weight: 700;
    margin-bottom: 10px;
  }
  &__line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0 0 15px 0;
    &:last-child {
      margin: 0;
    }
  }
  &__label {
    font-family: var(--font-regular);
    text-transform: capitalize;
    font-size: rem(16);
    margin: 0;
    &--total {
      color: var(--white);
      text-transform: none;
      font-size: rem(18);
    }
  }
  &__value {
    font-family: var(--font-regular);
    font-size: rem(16);
    margin: 0;
    &--total {
      color: var(--white);
      text-transform: none;
      font-size: rem(16);
    }
    &--bf-discount {
      color: var(--purple-pale);
      font-size: rem(12px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(14px); /* 116.667% */
      margin-right: 10px;
    }
  }
  &__total {
    font-weight: 500;
    font-size: rem(18px);
    line-height: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-top: 1px solid #444444;
    padding-top: 5px;
  }
  &__total-group {
    background: linear-gradient(
      111.02deg,
      rgba(18, 18, 18, 0.7) 3.86%,
      rgba(18, 18, 18, 0) 107.96%
    );
    border-radius: 10px;
    padding: 15px;
    color: var(--white);
  }
}
</style>
